import { module } from "angular";
import badgesCore from "@gtmhub/badges/badges-core.module";
import upgrade from "@gtmhub/core/upgrade/module";
import employeesCore from "@gtmhub/employees/employees-core.module";
import feed from "@gtmhub/feed/feed.module";
import quantivePlusModule from "@gtmhub/goals/components/quantive-plus/quantive-plus.module";
import { Ng1LoginMobileWarningService } from "@gtmhub/login/services/ng1-login-mobile-warning.service";
import navigation from "@gtmhub/navigation/navigation.module";
import onboardingCore from "@gtmhub/onboarding/onboarding-core.module";
import reflectionsCore from "@gtmhub/reflections/reflections-core.module";
import teamsCore from "@gtmhub/teams/teams-core.module";
import { GridHeaderComponent } from "@webapp/home/components/grid-header/grid-header.component";
import { HomeDashboardComponent } from "@webapp/home/components/home-dashboard/home-dashboard.component";
import { OkrWorkflowService } from "@webapp/okrs/components/okr-workflow/okr-workflow.service";
import { TaskModalService } from "@webapp/tasks/services/task-modal.service";
import { HomeSkeletonComponent } from "../../../webapp/src/app/home/components/home-skeleton/home-skeleton.component";
import { HomeDashboardContainerComponent } from "./components/home-dashboard-container/home-dashboard-container.component";
import { HomeFeedNavBarComponent } from "./components/home-feed-nav-bar/home-feed-nav-bar.component";
import { HomeTodoComponent } from "./components/home-todo/home-todo.component";
import { DashboardComponent, DashboardCtrl } from "./controllers/dashboard";
import { HomeMyOkrs } from "./directives/my-okrs";
import { HomeProgress } from "./directives/progress";
import { HomeService } from "./services/home";

const mod = module("home", [upgrade, feed, quantivePlusModule, onboardingCore, navigation, badgesCore, employeesCore, teamsCore, reflectionsCore]);

mod.controller("DashboardCtrl", DashboardCtrl);
mod.service("HomeService", HomeService);
mod.component("homeTodo", HomeTodoComponent);
mod.directive("homeMyOkrs", HomeMyOkrs.factory());
mod.component("homeDashboardContainer", HomeDashboardContainerComponent);
mod.component("homeDashboardOld", DashboardComponent);
mod.component("homeFeedNavBar", HomeFeedNavBarComponent);
mod.downgradeComponent("homeSkeleton", { component: HomeSkeletonComponent, propagateDigest: false });
mod.downgradeComponent("homeDashboardNew", { component: HomeDashboardComponent, propagateDigest: false });
mod.downgradeComponent("gridHeader", { component: GridHeaderComponent, propagateDigest: false });
mod.downgradeInjectable("OkrWorkflowService", OkrWorkflowService);
mod.downgradeInjectable("TaskModalService", TaskModalService);
mod.directive("homeProgress", HomeProgress.factory());
mod.service("Ng1LoginMobileWarningService", Ng1LoginMobileWarningService);

export default mod.name;
